import Upload from './upload.view.js';

export default Upload;
